/**
 * We name this "external" for typedoc. The other internal modules are configured as entrypoints.
 * @module external
 */
/**
 * @deprecated Import from `@atlassian/ufo-experimental/experience-types` instead.
 */
export {
	UFOExperienceState,
	UFOExperience,
	ConcurrentExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	GlobalPageLoadExperience,
	ufologger,
	untilAll,
} from '@atlassian/ufo-experimental';
